/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useContext } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Header, LoneIconButton, Text } from '@blend/enterprise-components';
import { modalContentPadding } from 'blb-styles/constants';
import { DisablednessContext } from 'blb-contexts/Disabledness';
import { camelCase } from 'lodash';

const styles = StyleSheet.create({
  headerBar: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerText: {
    marginRight: 24,
    overflowWrap: 'anywhere',
  },
  modalContent: {
    maxHeight: 1000,
    overflow: 'auto',
    padding: modalContentPadding,
  },
  spacer: {
    marginBottom: 8,
  },
  subHeaderText: {
    marginBottom: 24,
  },
});

export namespace ModalContent {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    handleClose?: () => void;
    headerText: string;
    subHeaderText?: string;
  }
}

export const ModalContent: React.FC<ModalContent.Props> = ({
  headerText,
  children,
  subHeaderText,
  handleClose,
  ...htmlProps
}) => {
  const id = camelCase(headerText);
  const { disabled } = useContext(DisablednessContext);
  return (
    <div {...htmlProps} className={css(styles.modalContent)}>
      <div className={css(styles.headerBar, styles.spacer)}>
        <div className={css(styles.headerText)}>
          <Header size={4}>{headerText}</Header>
        </div>
        {handleClose && (
          <LoneIconButton
            disabled={disabled}
            icon="clear"
            id={`it-${id}-modal-close`}
            noBorder
            noHover
            onClick={handleClose}
            theme="tertiary"
          />
        )}
      </div>
      {subHeaderText && (
        <div className={css(styles.subHeaderText)}>
          <Text>{subHeaderText}</Text>
        </div>
      )}
      {children}
    </div>
  );
};
